<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>数据分析</i></el-breadcrumb-item>
                <el-breadcrumb-item>报表管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select clearable size='mini' v-model="queryParams.projectAppId" filterable placeholder="请选择">
                                    <el-option
                                        v-for="item in projectInfoList"
                                        :key="item.appId"
                                        :label="item.cnName"
                                        :value="item.appId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='埋点事件'>
                                <el-select clearable size='mini' v-model="queryParams.eventId" filterable placeholder="请选择">
                                    <el-option
                                        v-for="item in trackEventList"
                                        :key="item.id"
                                        :label="item.eventName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='事件ID' prop='name'>
                                <el-input
                                    v-model='queryParams.name'
                                    placeholder='请输入报表名字'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                    
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='trackAnalyseReportSettingList'
                      @sort-change='handleSortChange'>
                <el-table-column width='200' show-overflow-tooltip sortable='custom' label='报表名' align='center' prop='name' />
                <el-table-column label='目标事件' align='center' prop='yesterdayCount' >
                    <template slot-scope='scope'>
                        <el-link :underline="false" type="primary">{{computeEventName(scope.row)}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label='报表设置' show-overflow-tooltip align='center' prop='todayCount' >
                    <template slot-scope='scope'>
                        <span></span>
                    </template>
                </el-table-column>
                <el-table-column width='100' label='创建用户' align='center'>
                    <template slot-scope='scope'>
                        <span>{{computeUserAccount(scope.row)}}</span>
                    </template>
                </el-table-column>
                <el-table-column sortable='custom' label='创建时间' align='center' prop='createTime' />
                <el-table-column sortable='custom' label='更新时间' align='center' prop='updateTime' />
                <el-table-column
                    label='操作'
                    align='center'
                    width='200'
                    class-name='small-padding fixed-width'
                >
                    <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='40%' append-to-body>
                
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { selectEmployeeList } from '@api/dashboard';
import { trackEventApi } from '@api/Track/trackEvent';
import { message } from '@/utils/message';
import { projectInfoApi } from '@api/ProjectInfo';

export default {
    name: 'User',
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                eventId: undefined,
                projectAppId: undefined,
                name: undefined
            },
            
            adminUserList: [],
            trackAnalyseReportSettingList: [],
            currentTrackAnalyseReportSetting: {},
            trackEventList: [],
            eventMap: new Map,
            adminUserMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: []
            
        };
    },
    computed: {
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId))
                if (!event) {
                    return '未知'
                }else {
                    return event.eventName
                }
            }
        },
        computeUserAccount() {
            return (data) => {
                let user = this.adminUserMap.get(data.createUserId)
                if (!user) {
                    return '未知'
                }else {
                    return user.nickName
                }
            }
        },
    },
    created() {
        this.getList();
        this.initData()
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size
            this.queryParams.pageNum = 1
            this.getList()
        },
        async handleSortChange({column, prop, order}) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList)
            this.queryParams.pageNum = 1
            this.queryParams.pageSize = 15
            this.getList()
        },
        initData() {
            this.adminUserMap = new Map
            this.eventMap = new Map
            this.trackEventList = []
            this.projectInfoList = []
            selectEmployeeList({pageSize: 10000}).then(result => {
                this.adminUserList = result.data
                result.data.forEach(t => {
                    this.adminUserMap.set(t.userId, t)
                    this.mapTrackerNum++
                })
            })
            
            trackEventApi.queryTrackEvent({pageSize: 1000000}).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t)
                        this.mapTrackerNum = this.mapTrackerNum + 1
                    })
                }
            })
            
            projectInfoApi.query({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result
                }
            })
        },
        getList() {
            this.loading = true
            this.trackAnalyseReportSettingList = []
            trackReportSettingApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.trackAnalyseReportSettingList = result.data.result
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize
                }
                this.loading = false
            })
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList()
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
            }
            this.handleQuery()
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentDataInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this
            this.$modal.confirm('是否确认删除"' + row.name + '"的数据项？').then(function() {
                return  trackReportSettingApi.deleteData(row)
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message)
                    obj.getList()
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        }
    }
};
</script>